import { IUserAccountStore } from '../../index'
import { INotificationSyncAccepted } from '../../../../actions/notification/loadMore'

export default function(
  store: IUserAccountStore,
  action: INotificationSyncAccepted,
): IUserAccountStore {
  return {
    ...store,
    notifications: {
      ...store.notifications,
      count: action.notifications.count,
      countNotRead: action.notifications.countNotRead,
      countNotSeen: action.notifications.countNotSeen,
      isLoading: false,
      items: [
        ...action.notifications.items.filter(
          newNot =>
            !store.notifications.items.find(
              not => String(not.id) === String(newNot.id),
            ),
        ),
        ...store.notifications.items.map(
          not =>
            action.notifications.items.find(
              newNot => String(newNot.id) === String(not.id),
            ) || not,
        ),
      ].filter(not => !action.ids.find(id => String(not.id) === String(id))),
    },
  }
}
